import { Component } from '@angular/core';

@Component({
  selector: 'app-work-schedule-create',
  standalone: false,
  templateUrl: './work-schedule-create.component.html',
  styleUrl: './work-schedule-create.component.scss',
})
export class WorkScheduleCreateComponent {}
